import { PageData, PDFCitationPayload } from './pdf-utils/constants';
import { CitationReferenceData } from '../../../services/reference-generator/types';

export enum PDFViewerViewMode {
  DOCUMENT = 'DOCUMENT',
  THUMBNAIL = 'THUMBNAIL',
}


export interface PDFViewerProps {
  src?: string;
  base64Content?: string;
  allowPageSelection?: boolean;
  selectedPages?: Set<number>;
  onPageToggle?: (pageNumber: number) => void;
  viewMode: PDFViewerViewMode;
  jsonData?: PageData[];
  activeCitation?: CitationReferenceData;
  onCitationPushed?: (payload: PDFCitationPayload) => void;
}
